import React from 'react';
import styled from 'styled-components';

const CircleContainer = styled.div`
    width: 200vw;
    height: 115vw;
    max-height: 189vh;
    max-width: 200vh;
    background-color: #6AB8A8;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(0%, -50%);
    z-index: 0;
    overflow: hidden;

`;



const Circle = () => {
  return (
    <CircleContainer>
    </CircleContainer>
  );
};

export default Circle;
